import React from 'react';
import TextSnippetWrapper from 'components/TextSnippetWrapper';

function PrimeReactInputText(props) {
  const { name = '', value = '', onChange = () => {}, ...rest } = props || {};
  return (
    <>
      <TextSnippetWrapper type="text" name={name} value={value} onChange={onChange} {...rest} />
    </>
  );
}

export default PrimeReactInputText;
